/**
* SEO Flyout JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Flyout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'seo-flyout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.seo-flyout' ).each( function( key, val ) {
        const marquee = $( this ).find( '.seo-flyout__marquee' )[0];
        const marqueeVisibleWidth = $( marquee ).outerWidth();
        const marqueeWidth = $( marquee )[0].scrollWidth;
        const scrollAmount = ( marqueeWidth - marqueeVisibleWidth ) / 2;

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: '50% bottom',
            end: 'bottom top',
            scrub: 1,
          },
        } );

        tl.to( marquee, {x: '-' + scrollAmount, ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-flyout', COMPONENT );
} )( app );
